export var setCurrentSpot = spotId => ({
  type: "SET_CURRENT_SPOT",
  spotId
});
